import React, { forwardRef, useImperativeHandle,useRef,useEffect } from "react";
// import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from "react";
import ComponentTagSelector from "../tags/ComponentTagSelector";
// import { useClientTypes } from "../../context/ClientTypeContext"; 

import { useMasterData } from "../../context/MasterDataContext";



const Comp_Cities = forwardRef(({
    maxTags = undefined,
    // style = '',

    style={},   // container style
    tagStyle={},  // tags
    inputStyle={}, // input field


    defaultTags = [],
    selectedTags = [],
    setSelectedTags = () => {},

    onCitySelect,
    onCityRemove,
    onCityChangeTag,
    onCityNotFound,


}, ref) => {
    const placeHolder = "Select City";
    // const {clienttype:masterCities,ready:CitiesReady} = useClientTypes(); // Assuming this returns the list of property types

    const {cities:masterCities,citiesReady:CitiesReady}= useMasterData();
    

    const tagrefCities = useRef(null);
    const hasInitialized = useRef(false);


/**
     * Resolve Client Type IDs or mixed tags into full colony objects from masterClienttype.
     * @param {Array<number|string|object>} idsOrObjects
     * @param {string} defaultStatus
     * @returns {Array<object>}
     */
    function getObjectFromIds(idsOrObjects ,defaultStatus = "default") {
      if (!Array.isArray(idsOrObjects) || !Array.isArray(masterCities)) return [];
      return idsOrObjects
        .map(tagOrId => {
          if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'city' in tagOrId) {
            return tagOrId;
          }
          const rawId = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId)
            ? parseInt(tagOrId, 10)
            : tagOrId;
          return masterCities.find(col => {
            const cid = col.id;
            return (
              (typeof cid === 'number' && cid === rawId) ||
              (typeof cid === 'string' && cid === ('' + rawId))
            );
          });
        })
        .filter(Boolean)
        .map(ctype => ({
          ...ctype,
          status: defaultStatus
        }));
      }



        useEffect(() => {
            if (
                !hasInitialized.current && 
                Array.isArray(defaultTags) &&
                defaultTags.length > 0 &&
                tagrefCities.current &&
                CitiesReady &&
                Array.isArray(masterCities) &&
                masterCities.length > 0
                ) {
                tagrefCities.current.setTags(defaultTags);
                hasInitialized.current = true;
                // console.log("✅ setTags called with:", defaultTags);
            }
            {
            const initialTags = getObjectFromIds(defaultTags);
            tagrefCities.current.setTags(initialTags);
            hasInitialized.current = true;
        }
        // }, [defaultTags?.length,masterCities,CitiesReady]);
        }, [CitiesReady]);


        // useEffect(() => {
        //     if (!hasInitialized.current && defaultTags && defaultTags.length > 0 && tagrefCities.current) {
        //         tagrefCities.current.setTags(defaultTags);
        //         hasInitialized.current = true;
        //         // console.log("✅ setTags called with:", defaultTags);
        //     }
        // }, [defaultTags?.length]);




    // const [tags, setTags] = useState(defaultTags || []);

    // // Update tags when defaultTags changes
    // useEffect(() => {
    //     setTags(defaultTags || []);
    // }, [defaultTags]);

    // Debugging: Log defaultTags and masterUserTypes
    // useEffect(() => {
    //     // console.log("defaultTags in Comp_ClientTypes:", defaultTags);
    //     // console.log("masterCities in Comp_ClientTypes:", masterCities);
    // }, [defaultTags, masterCities]);

    const handleSelectTag = (tag) => {
        if (onCitySelect) {
            onCitySelect(tag);
        }
    };

    const handleRemoveTag = (tag) => {
        if (onCityRemove) {
            onCityRemove(tag);
        }
    };

    const handleChangeTag = (AllTags) => {
        if (onCityChangeTag) {
            onCityChangeTag(AllTags);
        }
    };

    const handleCityNotFound = (payload) => {
      // payload contains: value, displayKey, parentKey, etc.
      console.log("City not found",payload)
      if (onCityNotFound) {
        onCityNotFound({
          ...payload,
          source: "cities"
        });
      }
    };



    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        // getClientTypeTags: () => tagrefCities.current.getTags(),
        // setClientTypeTags: (selected) => tagrefCities.current.setTags(selected),
        getObjectFromIds,
        getCityTags: () => selectedTags,
        setCityTags: (tags) => setSelectedTags(tags),            
        getTagsbyIds: (ids) => getTags(ids)
    }));





    function getTags(ids) {
        if (ids.length > 0) {
            return masterCities.filter(record => ids.includes(record.id));
        } else {
            return [];
        }
    }

    return (
        <div>
            <ComponentTagSelector
                ref={tagrefCities}
                // style={style}

                style={style}        // container style
                tagStyle={tagStyle}  // tags
                inputStyle={inputStyle} // input field

                suggestions={masterCities} // Ensure this is populated
                defaultTags={defaultTags} // Use internal state for defaultTags
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}
                maxTags={maxTags}
                displayKey="city" // Ensure this matches the key in masterUserTypes
                // allowFreeAdd={true}
                placeHolder={placeHolder}
                onSelectTag={handleSelectTag}
                onRemoveTag={handleRemoveTag}
                onChangeTag={handleChangeTag}
                onTagNotFound={handleCityNotFound}

            />
            {/* Render tags */}
            {/* {tags.map((tag) => (
                <span key={tag.id}>{tag.name}</span>
            ))} */}
        </div>
    );
});

export default Comp_Cities;
